<template>
  <div class="vx-col w-1/2">
    <div class="vx-row mb-12">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Images
          <small class="text-danger">(jpg, jpeg, png only)</small>
        </span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <div class="vx-col w-1/2">
          <input
            id="fileInput"
            name="file"
            class="w-full inputx"
            type="file"
            ref="file"
            multiple="multiple"
            accept="image/png, image/jpeg, image/jpg"
          />
        </div>
      </div>
    </div>

    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <div class="vx-col sm:w-1/3 w-full">
        <span></span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-button class="mr-3 mb-2" @click="handleAttachment">Add Images</vs-button>
        </div>
      </div>
    </div>

    <vs-divider style="width: 50%; margin-left: 10%">List Images</vs-divider>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 50%; margin-left: 10%">
      <table class="vs-table vs-table--tbody-table">
        <template>
          <tr class="tr-values vs-table--tr tr-table-state-null selected" v-for="(tr, i) in image" :key="tr.NameFile">
            <td class="td vs-table--td">{{ tr.NameFile }}</td>
            <td class="td vs-table--td">
              <vx-tooltip text="Show">
                <vs-button type="line" icon-pack="feather" icon="icon-eye" @click.stop="handleShowAttachment(tr)" />
              </vx-tooltip>
            </td>
            <td class="td vs-table--td">
              <template>
                <vx-tooltip text="Delete">
                  <vs-button type="line" icon-pack="feather" icon="icon-trash" @click.stop="handleDeleteAttachment(i)" />
                </vx-tooltip>
              </template>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      image: [],
    }
  },
  methods: {
    handleAttachment() {
      const files = this.$refs.file.files;

      if (!files.length) {
        this.$vs.notify({
          title: "Error",
          text: "Please select an image.",
          color: "danger",
        });
        return;
      }

      const file = files[0];

      // Validate type
      if (!file.type.startsWith("image/")) {
        this.$vs.notify({
          title: "Error",
          text: "Only image files are allowed.",
          color: "danger",
        });
        return;
      }

      this.image.push({
        NameFile: file.name,
        File: file,
      });

      this.$refs.file.value = "";
      this.$emit("input", this.image);
    },
    handleShowAttachment(file) {
      let objectURL;
      objectURL = URL.createObjectURL(file.File);

      var href = objectURL;
      window.open(href, "_blank").focus();
    },
    handleDeleteAttachment(index) {
      this.image = this.image.filter((r, i) => {
        return i != index;
      });
      this.$emit('input', this.image); // Emit the input event
    },
  }
}
</script>
